import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 w-full">
        <div className="max-w-6xl mx-auto text-center py-16 px-4">
          <h1 className="text-4xl font-bold text-white mb-2">Privacy Policy</h1>
          <p className="text-teal-100 max-w-2xl mx-auto">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
      
      <div className="max-w-3xl mx-auto px-6">
        <div className="terms-content py-16 text-left">
          <section className="mb-8">
            <p className="terms-intro text-lg">
              At elef89, your privacy is important to us. This Privacy Policy explains what personal information we collect, how we use it, and your rights regarding your data.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. About elef89</h2>
            <p>
              elef89 provides an automated service that helps users upload their mobile applications (APK, AAB, IPA) to app stores. Our system handles the upload process using the credentials and information provided by the user. We do not collect or share app content or user data from your applications.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
            <p className="mb-3">
              We may collect limited personal information directly from you, such as:
            </p>
            <ul className="mb-4 ml-6 space-y-2 list-disc">
              <li>Your name</li>
              <li>Email address</li>
              <li>Company details</li>
            </ul>
            <p>
              We do not collect any end-user data from your applications. We only handle the information required to perform the upload service.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. How We Use Your Information</h2>
            <p className="mb-3">
              We use the information we collect to:
            </p>
            <ul className="mb-4 ml-6 space-y-2 list-disc">
              <li>Operate and provide our app upload services</li>
              <li>Communicate with you regarding your account, uploads, and service updates</li>
              <li>Improve our platform and user experience</li>
            </ul>
            <p>
              We do not sell or share your personal data with third parties, except as necessary to provide the service (for example, using your credentials to upload to the store on your behalf).
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Data Security</h2>
            <p className="mb-3">
              We take appropriate technical and organizational measures to protect your information. Sensitive data, such as app store credentials, is handled securely and only used for the purpose of completing the upload process.
            </p>
            <p>
              However, no online service can guarantee absolute security. Please use strong passwords and protect your accounts.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Your Rights</h2>
            <p>
              You may request access to, correction of, or deletion of your personal information by contacting us at davidd@elef89.com.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Contact</h2>
            <p className="mb-2">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="contact-info">
              📧 <a href="mailto:davidd@elef89.com" className="text-teal-400 hover:text-teal-300">davidd@elef89.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 